module.exports = __webpack_public_path__ + "public/img/tipycj.14bebb50.png";